import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { If } from '../If/If';
import {
  Body, BodyButtons, BodyContent, Container,
  Header, HeaderContent, HeaderIndicator
} from './styles';

interface ICollapsibleCardProps {
  showExpanded: boolean;
  header?: React.ReactNode;
  buttons?: React.ReactNode;
  marginBottom?: string;
}

export const CollapsibleCard: React.FC<ICollapsibleCardProps> = ({
  children,
  showExpanded,
  header,
  buttons,
  marginBottom
}) => {

  const [expanded, setExpanded] = React.useState<boolean>(showExpanded);

  return (
    <Container marginBottom={marginBottom}>
      <Header onClick={() => setExpanded(!expanded)}>
        <HeaderIndicator>
          <FontAwesomeIcon icon={expanded ? faCaretDown : faCaretRight} color='gray' size='lg' />
        </HeaderIndicator>
        <HeaderContent>
          {header}
        </HeaderContent>
      </Header>
      <If condition={expanded}>
        <Body>
          <BodyContent>
            {children}
          </BodyContent>
          {buttons ? <BodyButtons>{buttons}</BodyButtons> : null}
        </Body>
      </If>
    </Container>
  );
}